import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            "AIzaSyC1HUfx5pi0qZYvoOT7Y20hQJju6NU8liE",
  authDomain:        "revolutionary-foundation.firebaseapp.com",
  projectId:         "revolutionary-foundation",
  storageBucket:     "revolutionary-foundation.firebasestorage.app",
  messagingSenderId: "1007956245776",
  appId:             "1:1007956245776:web:1e2b1587f2884560d1b995",
};

const app        = initializeApp(firebaseConfig);
export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export default app;
